import Input from '../../ui/Input';
import Heading from '../../ui/Heading';
import Button from '../../ui/Button';
import AddProfileImage from '../../assets/icons/AddProfileImage';
import Info from '../../assets/icons/Info';
import BackButton from '../../assets/icons/BackButton';
import { useNavigate, useParams } from 'react-router-dom';
import { useState } from 'react';
import Loader from '../../ui/Loader';
import { useLoadingState } from '../../hooks/useLoader';
import { uploader } from '../../helpers/uploader';
import { toast } from 'sonner';
import EditLogo from '../../assets/icons/EditLogo';
import CharacterLimit from '../../ui/CharacterLimit';
import { createEvent } from '../../apis/events/createEvent';
import { updateEvent } from '../../apis/events/updateEvent';
import DescriptionWithPara from '../../ui/DescriptionWithPara';
import ButtonNew from '../../ui/ButtonNew';
import { compressImage } from '../../helpers/compressor';

function EventInput({
    errors,
    eventNameField,
    eventHeadingField,
    eventDescriptionField,
    handleSubmit,
    imageObject,
    setImage,
    editId,
    landingImageObject,
    register,

    setLandingImage,
    setErrorFunc,
    clearErrorsFunc,
}) {
    const { id } = useParams();
    const { loading, startLoading, stopLoading } = useLoadingState();
    const [uploadStatus, setUploadStatus] = useState('');

    // Separate loading states
    const { loading: bannerUploading, startLoading: startBannerUploading, stopLoading: stopBannerUploading } = useLoadingState();
    const { loading: landingUploading, startLoading: startLandingUploading, stopLoading: stopLandingUploading } = useLoadingState();

    const navigate = useNavigate();

    const { image, imageURL } = imageObject;
    const onSubmit = async (data) => {
        data.eventBanner = landingImageObject.imageURL;
        data.eventLandingImage = imageObject.imageURL;
        // data.eventLandingImage = landingImageObject.imageURL;
        const payloadData = {
            name: data.eventName,
            bannerImages: [data.eventBanner],
            sections: [
                {
                    title: data.eventHeading,
                    content: data.eventDescription,
                },
            ],
            image: data.eventLandingImage,
            buttonPosition: 1,
            organisationId: id,
        };

        if (editId) {
            const { organisationId, ...editData } = payloadData;
            startLoading();
            const response = await updateEvent(editData, editId);
            stopLoading();
            if (Object.keys(response).length > 0) navigate(-1);

            return;
        }

        startLoading();

        const response = await createEvent(payloadData);

        stopLoading();
        if (Object.keys(response).length > 0) navigate(-1);
    };
    const handleFileChange = async (event) => {
        const file = event.target.files[0]; // Get the selected file

        if (file) {
            await uploadFile(file);
        } else {
            setUploadStatus('Please select a valid  file.');
        }
    };

    const handleFileLandingChange = async (event) => {
        const file = event.target.files[0]; // Get the selected file

        if (file) {
            await uploadFileLanding(file);
        } else {
            setUploadStatus('Please select a valid  file.');
        }
    };
    const uploadFile = async (file) => {
        try {
            startBannerUploading();
            const fileToUpload = await compressImage(file, 9.5);
            clearErrorsFunc('eventBanner');

            const res = await uploader(fileToUpload);

            if (res.files.length) {
                setImage({
                    image: file,
                    imageURL: res.files[0],
                });

                toast.success('Image is successfully uploaded.');
            } else {
                toast.error('Sorry unable to upload logo');
            }
            stopBannerUploading();
        } catch (error) {
            console.error('Error uploading file:', error);
            const errorMessage = error?.message || (typeof error === 'string' ? error : 'File upload failed.');
            setErrorFunc('eventBanner', {
                type: 'manual',
                message: errorMessage
            });
            stopBannerUploading();
        }
    };
    const uploadFileLanding = async (file) => {
        try {
            startLandingUploading();
            const fileToUpload = await compressImage(file, 9.5);
            clearErrorsFunc('eventLandingImage');

            const res = await uploader(fileToUpload);

            if (res.files.length) {
                setLandingImage({
                    image: file,
                    imageURL: res.files[0],
                });

                toast.success('Image is successfully uploaded.');
            } else {
                toast.error('Sorry unable to upload logo');
            }
            stopLandingUploading();
        } catch (error) {
            console.error('Error uploading file:', error);
            const errorMessage = error?.message || (typeof error === 'string' ? error : 'File upload failed.');
            setErrorFunc('eventLandingImage', {
                type: 'manual',
                message: errorMessage
            });
            stopLandingUploading();
        }
    };

    if (editId) {
        if (!eventDescriptionField?.value) return <Loader />;
        else
            return (
                <div className=" flex gap-3 items-start py-6  overflow-auto main pr-[55px] ">
                    <BackButton className={'relative top-2'} onClick={() => navigate(-1)} />
                    <form onSubmit={handleSubmit(onSubmit)} className=" w-[100%] ">
                        <div className="mb-7 ">
                            <Heading type="medium" className="capitalize text-textPrimary  mb-2">
                                Event Title <sup className="text-lg relative top-[1px]">*</sup>
                            </Heading>
                            <Input
                                {...eventNameField}
                                error={errors?.eventName?.message}
                                placeholder={'Type your Event’s Title'}
                                className={'w-[100%]'}
                            />
                            <CharacterLimit min={eventNameField.value ? eventNameField.value.length : 0} max={20} />
                        </div>
                        <div className="mb-7">
                            <div className="p-6 pt-5 bg-grayBgNormal shadow-sm rounded-md ">
                                <Heading type="medium" className="text-textPrimary leading-tight mb-2">
                                    Upload an image for the banner <sup className="text-lg relative top-[1px]">*</sup>
                                </Heading>
                                <div className="flex flex-col text-uploadText items-center">
                                    <div className="border flex flex-col gap-2 border-borderUnderline border-dashed w-full p-6 rounded-md">
                                        <div>
                                            <div>
                                                {!imageObject.imageURL ? (
                                                    bannerUploading ? (
                                                        <div className="flex flex-col gap-2 items-center justify-center p-4">
                                                            <Loader />
                                                            <p className="text-sm font-medium animate-pulse">Compressing & Uploading...</p>
                                                        </div>
                                                    ) : (
                                                        <>
                                                            <label
                                                                className="flex flex-col gap-2 items-center"
                                                                htmlFor="bannerInput"
                                                            >
                                                                <AddProfileImage />
                                                                <p>Click to choose files</p>
                                                            </label>
                                                            <Input
                                                                id="bannerInput"
                                                                type="file"
                                                                {...register('eventBanner', {
                                                                    required: 'Please upload an event banner.',
                                                                })}
                                                                onChange={(e) => handleFileChange(e)}
                                                            />
                                                        </>
                                                    )
                                                ) : (
                                                    <div className="relative">
                                                        <img
                                                            className="w-20 h-20 rounded-md object-center object-cover"
                                                            src={imageObject?.imageURL}
                                                            alt="profile"
                                                        />
                                                        <label
                                                            htmlFor="bannerInput"
                                                            className="cursor-pointer absolute top-0 right-0 "
                                                        >
                                                            <EditLogo />
                                                            <Input
                                                                id="bannerInput"
                                                                type="file"
                                                                onChange={(e) => handleFileChange(e)} // No need to register here
                                                            />
                                                        </label>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        {!imageURL && (
                                            <div className="flex gap-2 justify-center items-center">
                                                <Info />
                                                <p className="font-semibold">
                                                    Ideal File Size: 9.5MB; Ideal dimensions: 670x260 px
                                                </p>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <p className="text-foundryRed mt-1">{errors?.eventBanner?.message}</p>
                        </div>
                        <div className="mb-7">
                            <div className="p-6 pt-5 bg-grayBgNormal shadow-sm rounded-md ">
                                <Heading type="medium" className="text-textPrimary leading-tight mb-2">
                                    Upload an image for the landing page{' '}
                                    <sup className="text-lg relative top-[1px]">*</sup>
                                </Heading>
                                <div className="flex flex-col text-uploadText items-center">
                                    <div className="border flex flex-col gap-2 border-borderUnderline border-dashed w-full p-6 rounded-md">
                                        <div>
                                            <div>
                                                {!landingImageObject.imageURL ? (
                                                    landingUploading ? (
                                                        <div className="flex flex-col gap-2 items-center justify-center p-4">
                                                            <Loader />
                                                            <p className="text-sm font-medium animate-pulse">Compressing & Uploading...</p>
                                                        </div>
                                                    ) : (
                                                        <>
                                                            <label
                                                                className="flex flex-col gap-2 items-center"
                                                                htmlFor="landingInput"
                                                            >
                                                                <AddProfileImage />
                                                                <p>Click to choose files</p>
                                                            </label>

                                                            <Input
                                                                id="landingInput"
                                                                type="file"
                                                                {...register('eventLandingImage', {
                                                                    required: 'Please upload a landing page image.',
                                                                })}
                                                                onChange={(e) => handleFileLandingChange(e)}
                                                            />
                                                        </>
                                                    )
                                                ) : (
                                                    <div className="relative">
                                                        <img
                                                            className="w-20 h-20 rounded-md object-center object-cover"
                                                            src={landingImageObject.imageURL}
                                                            alt="profile"
                                                        />
                                                        <label
                                                            htmlFor="landingInput"
                                                            className="cursor-pointer absolute top-0 right-0 "
                                                        >
                                                            <EditLogo />
                                                            <Input
                                                                id="landingInput"
                                                                type="file"
                                                                onChange={(e) => handleFileLandingChange(e)} // No need to register here
                                                            />
                                                        </label>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        {!landingImageObject?.imageURL && (
                                            <div className="flex gap-2 justify-center items-center">
                                                <Info />
                                                <p className="font-semibold">
                                                    Ideal File Size: 9.5MB; Ideal dimensions: 433x623 px
                                                </p>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <p className="text-foundryRed mt-1">{errors?.eventLandingImage?.message}</p>
                        </div >
                        <div className="mb-7">
                            <Heading type="medium" className="capitalize text-textPrimary  mb-2">
                                Heading <sup className="text-lg relative top-[1px]">*</sup>
                            </Heading>
                            <Input
                                {...eventHeadingField}
                                error={errors?.eventHeading?.message}
                                placeholder={'Please enter a short heading that will be displayed on Impact Miner'}
                                className={'w-[100%]'}
                            />
                            <CharacterLimit min={eventHeadingField?.value?.length} max={200} />
                        </div>
                        <div className="mb-7">
                            <DescriptionWithPara
                                errors={errors}
                                field={eventDescriptionField}
                                errorField={'eventDescription'}
                            />
                        </div>

                        <div>
                            {editId ? (
                                <Button type="submit" variant="secondary" width="w-[50%]" size="large">
                                    {loading ? <Loader /> : 'Update Event'}
                                </Button>
                            ) : (
                                <Button type="submit" variant="secondary" size="large" width="w-[50%]">
                                    {!loading ? ' Create Event' : <Loader />}
                                </Button>
                            )}
                        </div>
                    </form >
                </div >
            );
    }

    return (
        <div className=" flex gap-3 items-start py-6  overflow-auto main pr-[55px] ">
            <BackButton className={'relative top-2'} onClick={() => navigate(-1)} />
            <form onSubmit={handleSubmit(onSubmit)} className=" w-[100%] ">
                <div className="mb-7 ">
                    <Heading type="medium" className="capitalize text-textPrimary  mb-2">
                        Event Title <sup className="text-lg relative top-[1px]">*</sup>
                    </Heading>
                    <Input
                        {...eventNameField}
                        error={errors?.eventName?.message}
                        placeholder={'Type your Event’s Title'}
                        className={'w-[100%]'}
                    />
                    <CharacterLimit min={eventNameField.value ? eventNameField.value.length : 0} max={20} />
                </div>
                <div className="mb-7">
                    <div className="p-6 pt-5 bg-grayBgNormal shadow-sm rounded-md ">
                        <Heading type="medium" className="text-textPrimary leading-tight mb-2">
                            Upload an image for the banner <sup className="text-lg relative top-[1px]">*</sup>
                        </Heading>
                        <div className="flex flex-col text-uploadText items-center">
                            <div className="border flex flex-col gap-2 border-borderUnderline border-dashed w-full p-6 rounded-md">
                                <div>
                                    <div>
                                        {!imageObject.imageURL ? (
                                            bannerUploading ? (
                                                <div className="flex flex-col gap-2 items-center justify-center p-4">
                                                    <Loader />
                                                    <p className="text-sm font-medium animate-pulse">Compressing & Uploading...</p>
                                                </div>
                                            ) : (
                                                <>
                                                    <label
                                                        className="flex flex-col gap-2 items-center"
                                                        htmlFor="bannerInput"
                                                    >
                                                        <AddProfileImage />
                                                        <p>Click to choose files</p>
                                                    </label>
                                                    <Input
                                                        id="bannerInput"
                                                        type="file"
                                                        {...register('eventBanner', {
                                                            required: 'Please upload an event banner.',
                                                        })}
                                                        onChange={(e) => handleFileChange(e)}
                                                    />
                                                </>
                                            )
                                        ) : (
                                            <div className="relative">
                                                <img
                                                    className="w-20 h-20 rounded-md object-center object-cover"
                                                    src={imageObject?.imageURL}
                                                    alt="profile"
                                                />
                                                <label
                                                    htmlFor="bannerInput"
                                                    className="cursor-pointer absolute top-0 right-0 "
                                                >
                                                    <EditLogo />
                                                    <Input
                                                        id="bannerInput"
                                                        type="file"
                                                        onChange={(e) => handleFileChange(e)} // No need to register here
                                                    />
                                                </label>
                                            </div>
                                        )}
                                    </div>
                                </div>
                                {!imageURL && (
                                    <div className="flex gap-2 justify-center items-center">
                                        <Info />
                                        <p className="font-semibold">
                                            Ideal File Size: 9.5MB; Ideal dimensions: 670x260 px
                                        </p>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    <p className="text-foundryRed mt-1">{errors?.eventBanner?.message}</p>
                </div>
                <div className="mb-7">
                    <div className="p-6 pt-5 bg-grayBgNormal shadow-sm rounded-md ">
                        <Heading type="medium" className="text-textPrimary leading-tight mb-2">
                            Upload an image for the landing page <sup className="text-lg relative top-[1px]">*</sup>
                        </Heading>
                        <div className="flex flex-col text-uploadText items-center">
                            <div className="border flex flex-col gap-2 border-borderUnderline border-dashed w-full p-6 rounded-md">
                                <div>
                                    <div>
                                        {!landingImageObject.imageURL ? (
                                            landingUploading ? (
                                                <div className="flex flex-col gap-2 items-center justify-center p-4">
                                                    <Loader />
                                                    <p className="text-sm font-medium animate-pulse">Compressing & Uploading...</p>
                                                </div>
                                            ) : (
                                                <>
                                                    <label
                                                        className="flex flex-col gap-2 items-center"
                                                        htmlFor="landingInput"
                                                    >
                                                        <AddProfileImage />
                                                        <p>Click to choose files</p>
                                                    </label>

                                                    <Input
                                                        id="landingInput"
                                                        type="file"
                                                        {...register('eventLandingImage', {
                                                            required: 'Please upload a landing page image.',
                                                        })}
                                                        onChange={(e) => handleFileLandingChange(e)}
                                                    />
                                                </>
                                            )
                                        ) : (
                                            <div className="relative">
                                                <img
                                                    className="w-20 h-20 rounded-md object-center object-cover"
                                                    src={landingImageObject.imageURL}
                                                    alt="profile"
                                                />
                                                <label
                                                    htmlFor="landingInput"
                                                    className="cursor-pointer absolute top-0 right-0 "
                                                >
                                                    <EditLogo />
                                                    <Input
                                                        id="landingInput"
                                                        type="file"
                                                        onChange={(e) => handleFileLandingChange(e)} // No need to register here
                                                    />
                                                </label>
                                            </div>
                                        )}
                                    </div>
                                </div>
                                {!landingImageObject?.imageURL && (
                                    <div className="flex gap-2 justify-center items-center">
                                        <Info />
                                        <p className="font-semibold">
                                            Ideal File Size: 9.5MB; Ideal dimensions: 433x623 px
                                        </p>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    <p className="text-foundryRed mt-1">{errors?.eventLandingImage?.message}</p>
                </div>
                <div className="mb-7">
                    <Heading type="medium" className="capitalize text-textPrimary  mb-2">
                        Heading <sup className="text-lg relative top-[1px]">*</sup>
                    </Heading>
                    <Input
                        {...eventHeadingField}
                        error={errors?.eventHeading?.message}
                        placeholder={'Please enter a short heading that will be displayed on Impact Miner'}
                        className={'w-[100%]'}
                    />
                    <CharacterLimit min={eventHeadingField?.value?.length} max={200} />
                </div>
                <div className="mb-7">
                    <DescriptionWithPara
                        errors={errors}
                        field={eventDescriptionField}
                        errorField={'eventDescription'}
                    />
                </div>

                <div>
                    {editId ? (
                        <ButtonNew
                            type="submit"
                            disabled={loading}
                            fixedMinWidth={true}
                            minWidthClass={"min-w-[50%]"}
                            variant="orange"
                            size="sm" >
                            {loading ? <Loader /> : 'Update Event'}
                        </ButtonNew>

                    ) : (
                        <ButtonNew
                            type="submit"
                            disabled={loading}
                            fixedMinWidth={true}
                            minWidthClass={"min-w-[50%]"}
                            variant="orange"
                            size="sm" >
                            {!loading ? ' Create Event' : <Loader />}
                        </ButtonNew>

                    )}
                </div>
            </form>
        </div>
    );
}

export default EventInput;
